import React from "react"; import { Avatar, Typography, Row, Col } from 'antd';
import male from '../media/ManagementTeam/male.png'
import female from '../media/ManagementTeam/female.png'
import { HashRouter as Router, Route, Routes, Link } from 'react-router-dom';

import YadavBhattarai from "../media/ManagementTeam/YADAV BHATTARAI.png";
import UdeshKhadka from "../media/ManagementTeam/UDESH KHADKA.png";
import KoshrajPokhrel from "../media/ManagementTeam/KOSHRAJ POKHREL.png";
import RamPrasadPandey from "../media/ManagementTeam/RAM PRASAD PANDEY.png";
import LokendraSotiMagar from "../media/ManagementTeam/LOKENDRA SOTI MAGAR.png";
import SushmitaKhatri from "../media/ManagementTeam/SUSMITA KHATRI.png";
import AnitaGautam from "../media/ManagementTeam/ANITA GAUTAM.png";
import JibanNeupane from "../media/ManagementTeam/ADV.JIBAN NEUPANE.png";




const { Title } = Typography;

const ManagementTeam = () => {
  const teamMembers = [
    {
      name: 'Yadav Bhattarai', src: YadavBhattarai, id: "YadavBhattarai", title: "Chairperson", address: "Syangja", bio: `I am a business professional with over a decade of experience in the dynamic fields of trading,
investment, hospitality and agriculture. My deep understanding of market trends, coupled with
strategic acumen, has enabled me to achieve significant success in these sectors.
My passion for business, combined with commitment to ethical practices, has made me a
respected figure in the industry. I am constantly exploring new opportunities and driving
innovation to stay ahead of the curve. By combining strategic foresight with a deep
understanding of market dynamics, I continue to shape the future of Brahma Jyoti Holdings
(BJHL).`, email: "ybh.brahmajyoti@gmail.com"
    },
    {
      name: 'Udesh Khadka', src: UdeshKhadka, id: "UdeshKhadka", title: "CEO", address: "Ramechhap", bio: `I am a seasoned investment professional with over 10 years of experience in advising clients
on a wide range of investment strategies. Having honed the skills in the dynamic Nepali market,
I possess a deep understanding of the country's financial landscape, particularly in the green
energy and financial sectors.
Before assuming the role of CEO at Brahma Jyoti Holdings Limited, I held a significant position
at a renowned Nepali company, where I provided expert investment advice to clients. My
extensive experience in stock trading has equipped me with a keen eye for identifying lucrative
opportunities and managing risk effectively.
I bring a wealth of knowledge and expertise to Brahma Jyoti Holdings Limited where my
strategic thinking, combined with a strong track record of successful investments, makes me a
valuable asset to the company and its stakeholders.`, email: "udesh.brahmajyoti@gmail.com"
    },
    {
      name: 'Koshraj Pokhrel', src: KoshrajPokhrel, id: "KoshrajPokhrel", title: "Director", address: "Dang", bio: `I am an accomplished professional with over 10 years of expertise in investment and trade,
known for strategic vision and strong leadership. My deep understanding of financial markets,
coupled with keen analytical skills, has allowed me to lead the company with a focus on
sustainable growth, risk management, and profitability. In my career, I have worked with a
diverse range of clients and industries, making them highly adaptable and insightful in
assessing market trends. With hands-on experience with investment portfolios and financial
planning has been integral to my ability to make informed decisions that drive long-term
success.
Also, I am known for the dedication to maintaining high standards of integrity, transparency, and

accountability with the ability to build strong relationships and collaborate effectively with
stakeholders has been a hallmark of my leadership style.`, email: "krp.brahmajyoti@gmail.com"
    },
    {
      name: 'Ram Prasad Pandey', src: RamPrasadPandey, id: "RamPrasadPandey", title: "Managing Director", address: "Nawalparasi", bio: `I am a savant entrepreneur and strategic thinker with over 12 years of experience spanning
administration, marketing, finance, and the stock market. My keen business acumen, coupled
with a relentless drive for innovation, has enabled me to consistently deliver exceptional results.
My journey is marked by a relentless pursuit of innovation and excellence. Also, my ability to
adapt to changing market dynamics and embrace new technologies has allowed me to
consistently deliver outstanding results. I am committed to creating sustainable businesses in
the Brahma Groups of Companies that will surely have a positive impact on society.`, email: "rpp.brahmajyoti@gmail.com"
    },

    {
      name: 'Susmita Khatri', src: SushmitaKhatri, id: "SusmitaKhatri", title: "Director", address: "Dolakha", bio: `I am a dedicated professional with over six years of experience in administration and human
resources management in one of Nepal's most reputed organizations. Currently serving as a
Board of Directors at Brahma Jyoti Holdings Limited, where I leverage my extensive expertise to
oversee organizational strategy and ensure operational excellence.
My proven leadership in managing HR policies, employee engagement, and administrative
operations has significantly contributed to the growth and efficiency of the institutions I have
been associated with. Moreover, I have been recognized for strategic vision, effective
communication, and commitment to fostering a positive and productive workplace environment.`, email: "susmita.brahmajyoti@gmail.com"
    },
    {
      name: 'Anita Gautam', src: AnitaGautam, id: "AnitaGautam", title: "Director", address: "Kavrepalanchowk", bio: `I am a distinguished professional with over seven years of experience in stock trading, portfolio
management, and the hotel and tourism sector in Nepal. I serve as a Board of Directors at
Brahma Jyoti Holdings Limited, where my strategic insights and leadership contribute to the
organization's growth and innovation.
With a strong background in financial planning, investment strategies, and operational
management, I have established myself as a key figure in Nepal's financial and hospitality
industries. My dedication, analytical expertise, and visionary approach make an invaluable asset
to the company and the sectors I represent.`, email: "anita.brahmajyoti@gmail.com"
    },
    {
      name: 'Lokendra Soti Magar', src: LokendraSotiMagar, id: "LokendraSotiMagar", title: "Director", address: "Nawalparasi", bio: `I am a dynamic Professional in Global Trade and Hospitality with over a decade of experience
spanning the export, import, financial and hospitality sectors. I represent myself as a versatile
and accomplished professional whose expertise lies in navigating complex international trade
dynamics, managing financial operations, and delivering exceptional hospitality services.
My dedication to excellence and ability to adapt to diverse business environments have made
me a valuable asset to organizations across various industries. My strong interpersonal skills,
combined with strategic thinking and problem-solving abilities, enables me to drive growth and
achieve sustainable success.`, email: "lsm.brahmajyoti@gmail.com"
    },
//     {
//       name: 'Jiban Neupane', src: JibanNeupane, id: "JibanNeupane", title: "Company Secretary", address: "Kathmandu", bio: `I am a tenacious corporate lawyer with over a decade of experience in navigating complex legal
// landscapes. Having honed my skills at the prestigious BJHL, I have brought a wealth of
// expertise to the table. My areas of expertise include mergers and acquisitions, corporate
// governance, contract negotiation, regulatory compliance and dispute resolution.
// Moreover, I am known for strategic approach, results-oriented mindset and strong client
// relationships with a deep understanding of the legal challenges and opportunities faced by
// businesses and are committed to delivering practical, cost-effective solutions.`, email: "jiban.brahmajyoti@gmail.com"
//     },
  ];
  return (
    <div className="management-team-container">
      <div className="content">
        <h1>Management Team</h1>
        <Row gutter={[16, 16]} justify="center">
          {teamMembers.map((member, index) => (
            <Col xs={24} sm={12} md={6} key={index} className="avatar-column">
              {/* <a href={"/#/profile?profile=" + member.id}> */}
              <Link to="/profile" state={member} >

                <div className="avatar-item">
                  {/* <Avatar shape="square" src={member.src} size={150} style={{ margin: '10' }} /> */}
                  <img src={member.src} width={140} style={{ margin: '10' }} />
                  <div ><strong>{member.name}</strong></div>
                  <div >{member.title}</div>
                </div>
                {/* </a> */}
              </Link>
            </Col>
          ))}
        </Row>
      </div>



    </div>
  )
}


export default ManagementTeam;